import { json } from "stream/consumers";

class Helper {
    exportExcelError = (err, nameFile: string) => {
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        const blob = new File([err], 'filename.json', { type: 'text/json;charset=utf-8' });
        const objectURL = URL.createObjectURL(blob);
        link.href = objectURL;
        link.href = URL.createObjectURL(blob);
        link.download = nameFile;
        link.click();
    };

    exportExcel = (response) => {
        const outputFilename = `Danhsachtruyennhandulieu.xlsx`;

        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        const blob = new File([response.data], outputFilename, { type: 'text/json;charset=utf-8' });
        const objectURL = URL.createObjectURL(blob);
        link.href = objectURL;
        link.download = outputFilename;
        link.click();
    };

    prettifyXml = (sourceXml) => {
        try {
            let xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
            let xsltDoc = new DOMParser().parseFromString(
                [
                    // describes how we want to modify the XML - indent everything
                    '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
                    '  <xsl:strip-space elements="*"/>',
                    '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
                    '    <xsl:value-of select="normalize-space(.)"/>',
                    '  </xsl:template>',
                    '  <xsl:template match="node()|@*">',
                    '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
                    '  </xsl:template>',
                    '  <xsl:output indent="yes"/>',
                    '</xsl:stylesheet>',
                ].join('\n'),
                'application/xml'
            );

            let xsltProcessor = new XSLTProcessor();
            xsltProcessor.importStylesheet(xsltDoc);
            let resultDoc = xsltProcessor.transformToDocument(xmlDoc);
            const resultXml = new XMLSerializer().serializeToString(resultDoc);
            return resultXml;
        } catch (e) {
            console.log(e);
            return sourceXml;
        }
    };

    convertJson = (value) => {
        try {
            let jsonData = JSON.parse(value);
            let data = jsonData.data || '';
            if (data && typeof data === 'string' && this.isBase64(data)) {
                data = this.decodeBase64(data);
            } else {
                return value;
            }
            return this.prettifyXml(data)
        } catch (e) {
            return value ? this.prettifyXml(value) : '';
        }
    }

    decodeBase64(value: string) {
        return decodeURIComponent(escape(atob(value)));
    }

    isBase64(str) {
        if (str === '' || str.trim() === '') { return false; }
        try {
            return btoa(atob(str)) == str;
        } catch (err) {
            return false;
        }
    }
    formatTodayVietnamese = () => {
        let date, month, year;

        date = new Date().getDate();
        month = new Date().getMonth() + 1; // take care of the month's number here ⚠️
        year = new Date().getFullYear();
        if (date < 10) {
            date = '0' + date;
        }

        if (month < 10) {
            month = '0' + month;
        }
        date = date
            .toString()
            .padStart(2, '0');

        month = month
            .toString()
            .padStart(2, '0');
        const todayDate = `${date}${month}${year}`;
        return todayDate;
    }

    makeRequestId = (length = 6) => {
        const getNow = this.getNow();
        const randomStr = this.randomNumberString(length);
        return `${getNow}${randomStr}`;
    }

    getNow = () => {
        const date = new Date().getTime();
        if (date) {
            return date
        }
    }

    randomNumberString = (length, str = '0123456789') => {
        return this.randomString(length, str);
    }

    randomString = (length = 10, str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
        const crypto = window.crypto;
        const arr = new Uint32Array(1);
        let result = '';
        const characters = str;
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            const index = (Number(crypto.getRandomValues(arr).toString()) % 10) / 10;
            result += characters.charAt(Math.floor(index * charactersLength));
        }
        return result;
    }

    removeEmpty(obj: any) {
        const newObj = {};
        Object.entries(obj).forEach(([k, v]) => {
            if (v === Object(v)) {
                newObj[k] = this.removeEmpty(v);
            } else if (v != null) {
                newObj[k] = obj[k];
            }
        });
        return newObj;
    }
}


export default new Helper();
